import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  DEFAULT_VARIANT_PATH,
  defaultVariantSearchSchema,
} from '@/features/agentic-insights/components/experimental/variants/defaultVariant';
import { agenticInsightsBeforeLoad } from '../index';

/**
 * The experimental namespace's own stable address — distinct from the nav item's bare route, which
 * renders the default variant directly rather than redirecting into `/experimental/...` (see
 * `../index.tsx`). This one is for a reader who intentionally navigates into variant-picker space (or
 * a link shared from inside it) and means "the default variant, whichever one that currently is": it
 * redirects to `DEFAULT_VARIANT_PATH` (`defaultVariant.tsx`), the one place naming which variant that
 * is, rather than a second hardcoded path here.
 *
 * It validates against that variant's schema and hands the search on, so a link that named a run
 * still arrives on that run rather than on the latest.
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/experimental/')(
  {
    validateSearch: (search) => defaultVariantSearchSchema.parse(search),
    beforeLoad: async (args) => {
      await agenticInsightsBeforeLoad(args);

      throw redirect({
        to: DEFAULT_VARIANT_PATH,
        params: args.params,
        search: args.search,
        replace: true,
      });
    },
  },
);
